export default __webpack_public_path__ + "static/media/sidebar-orange-dark.63a35d1a.png";